module.exports = __webpack_public_path__ + "static/media/cutscene-3.f053600c.mp4";